import * as React from 'react';

import { IOrganizationSearch } from '@/client/legacy-shared-modules/search/search-types';
import { OrganizationHit } from '@/imports/ui/components/search/OrganizationHits';

import { CardDividerList } from '../shared/CardDividerList';

export const OrganizationsList: React.FC<{
  hits: IOrganizationSearch[];
}> = ({ hits }) => {
  if (hits.length === 0) {
    return null;
  }

  return (
    <CardDividerList>
      {hits.map((organizationHit) => (
        <React.Fragment key={organizationHit.objectID}>
          {OrganizationHit(organizationHit, 'default', true)}
        </React.Fragment>
      ))}
    </CardDividerList>
  );
};
